import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

const CreateModel = ({ isOpen, setIsOpen }) => {
  const onCloseModal = () => setIsOpen(false);
  const [selectedProvider, setSelectedProvider] = useState();
  const [tokenValue, setTokenValue] = useState(50);

  return (
    <>
      <Modal open={isOpen} onClose={onCloseModal} center>
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-[20px] font-semibold text-gray-800">
            Create Model
          </h2>
        </div>
        {/* Form */}
        <form className="space-y-6">
          {/* Model Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Model name
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none "
              placeholder="Enter model name"
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8">
              <div className="text-center text-gray-500">
                Drag or Select banner
              </div>
            </div>
          </div>

          {/* AI Provider Selection */}
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => setSelectedProvider("openai")}
              className={`flex items-center px-4 py-2 rounded-full ${
                selectedProvider === "openai"
                  ? "bg-[#27004a] text-white"
                  : "bg-white border border-gray-300"
              }`}
            >
              <span className="font-medium">OpenAI</span>
            </button>
            <button
              type="button"
              onClick={() => setSelectedProvider("gemini")}
              className={`flex items-center px-4 py-2 rounded-full ${
                selectedProvider === "gemini"
                  ? "bg-[#27004a] text-white"
                  : "bg-white border border-gray-300"
              }`}
            >
              <span className="font-medium">GeminiAI</span>
            </button>
          </div>

          {/* Model Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select AI Model
            </label>
            <div className="relative">
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md appearance-none focus:outline-none ">
                <option>Gpt-40</option>
                <option>Gpt-35-turbo</option>
                <option>Gemini-pro</option>
              </select>
              <KeyboardArrowDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none "
              rows={4}
            />
          </div>

          {/* Token Consumption Note */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-700">
                NOTE: Adding more messages cause large number of tokens
                consumption
              </span>
              {/* <HelpCircle className="h-5 w-5 text-gray-400" /> */}
            </div>
            <input
              type="range"
              min="0"
              max="100"
              value={tokenValue}
              onChange={(e) => setTokenValue(parseInt(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#27004a] text-white py-3 px-4 rounded-lg hover:bg-[#27004a] transition-colors"
          >
            Add Ai Model
          </button>
        </form>
      </Modal>
    </>
  );
};
export default CreateModel;
